import Backbone from 'backbone';
import i18n, { t }  from '../../i18n/i18n.js';

var template = '<div class="empty-body"><div class="centered"><div class="message">{side_nav.reports.pick_report_message}</div></div></div>';

/** @class ReportsIndexPage */
var ReportsIndexPage = Backbone.View.extend(
    /** @lends ReportsIndexPage.prototype */
    {

        className: 'main-body',

        render: function () {

            this.$el.html(i18n.processLocalizedString(template));

            return this;
        }

    }
);

export default ReportsIndexPage;